import httpClient from './httpClient';
import axios from 'axios';

export default class BookingServices {
	
	static actionSubmited(formData){
		let inpFile = document.getElementById('inp-file');
		let uploadFile = inpFile.files[0];
		let params = new FormData();
		params.append( 'fullName', formData.fullName );
		params.append( 'company', formData.company );
		params.append( 'email', formData.email );
		params.append( 'message', formData.message );
		params.append( 'submit_form', formData.form );
		params.append( 'nda', formData.nda );
		params.append( 'project_period', formData.project_period );
		params.append( 'services', formData.services );
		params.append( 'total_order', formData.total_order );
		params.append( 'file_upload', uploadFile );
		params.append( 'file_uploads_count', formData.file_upload );
		params.append( 'action', 'bookingService' );
		params.append( 'security', document.getElementById( 'security' ).value );


		for (let index = 0; index < formData.file_upload; index++) {
			const element = inpFile.files[index];
			params.append( 'file_uploads_' + index, element );
		}

		return axios.post( settings.ajax_url, params );
	}
}
